import React from "react";

export function createTabHeaderTemplate(activeIndex: number) {
    return (options: any) => {
        const isActive = activeIndex === options.index;
        return (
            <div
                className={`group flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                    isActive
                        ? "bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400"
                        : "text-neutral-600 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-700 hover:text-neutral-900 dark:hover:text-neutral-100"
                }`}
                onClick={options.onClick}
            >
                <span className="font-semibold">{options.titleElement}</span>
            </div>
        );
    };
}
